import { a as w, t as m } from "./common-Cd7R8f1s.js";
import { n as p } from "./Logger-CmiOOsKC.js";
import { n as S, r as b, t as P } from "./imageanchor-DusNzbVp.js";
import { n as z, o as L, s as O } from "./documentRoot-BRVSd6Oa.js";
import { Quaternion as d, Vector3 as R } from "@babylonjs/core/Maths/math.vector.js";
import { Color3 as x, Color4 as A } from "@babylonjs/core/Maths/math.color.js";
var X = "image", tt = "groma", T = [
  0,
  0,
  0,
  1
];
function nt(t) {
  const n = t?.localizers;
  if (n == null) return null;
  const e = [];
  for (const r of n) {
    const o = _(r);
    o && e.push(o);
  }
  return e;
}
function _(t) {
  if (!t?.id) return null;
  const n = t.localizerId ?? t.localizer?.id;
  if (!n) return null;
  const e = E(t.t), r = C(t.q);
  return !e || !r ? null : {
    id: t.id,
    localizerId: n,
    t: e,
    q: r,
    rotationSource: t.rotationSource === "legacy_heuristic" ? "legacy_heuristic" : "explicit",
    isPrimary: t.isPrimary === !0,
    enabled: t.enabled !== !1,
    localizer: D(t.localizer, n)
  };
}
function D(t, n) {
  if (!t) return null;
  const e = t.widthM;
  return {
    id: t.id ?? n,
    kind: t.kind ?? "image",
    name: t.name ?? "",
    imageUrl: t.imageUrl || null,
    widthM: typeof e == "number" && Number.isFinite(e) && e > 0 ? e : null,
    displayAssetId: t.displayAssetId || null
  };
}
function E(t) {
  return t == null ? [
    0,
    0,
    0
  ] : t.length !== 3 || !t.every(Number.isFinite) ? null : [
    t[0],
    t[1],
    t[2]
  ];
}
function C(t) {
  if (t == null) return [...T];
  if (t.length !== 4 || !t.every(Number.isFinite)) return null;
  const n = Math.hypot(t[0], t[1], t[2], t[3]);
  return n < 1e-12 ? null : Math.abs(n - 1) < 1e-12 ? [
    t[0],
    t[1],
    t[2],
    t[3]
  ] : [
    t[0] / n,
    t[1] / n,
    t[2] / n,
    t[3] / n
  ];
}
function et(t) {
  return t?.find((n) => n.isPrimary && n.enabled && N(n));
}
function N(t) {
  return t.localizer?.kind === "image" && !!t.localizer.imageUrl;
}
function Q(t) {
  switch (t) {
    case m.Horizontal:
      return m.Horizontal;
    case m.Vertical:
      return m.Vertical;
    default:
      return m.Free;
  }
}
function v(t) {
  const n = d.RotationYawPitchRoll(0, t, 0);
  return [
    n.x,
    n.y,
    n.z,
    n.w
  ];
}
function ot(t, n) {
  const e = t == null ? void 0 : Q(t), r = n ?? void 0;
  return S(e, r) ? {
    q: null,
    rotationSource: "legacy_heuristic"
  } : {
    q: v(w(e, r)),
    rotationSource: "explicit"
  };
}
var g = 1e-6;
function rt(t) {
  if (t.t.some((a) => Math.abs(a) > g)) return null;
  const n = C(t.q);
  if (!n) return null;
  let [e, r, o, c] = n;
  if (Math.abs(r) > g || Math.abs(o) > g) return null;
  c < 0 && (e = -e, c = -c);
  const i = 2 * Math.atan2(e, c), s = i * 180 / Math.PI;
  return Math.abs(i) < g ? {
    orientation: m.Vertical,
    pitchDegrees: 0
  } : Math.abs(i + Math.PI / 2) < g ? {
    orientation: m.Horizontal,
    pitchDegrees: 0
  } : {
    orientation: m.Free,
    pitchDegrees: Math.abs(s + 180) < g ? 180 : s
  };
}
function at(t, n = /* @__PURE__ */ new Map()) {
  return { placements: t.map((e) => {
    const r = n.get(e.id);
    return {
      localizerId: e.localizerId,
      t: [...e.t],
      q: r ? [...r] : [...e.q],
      isPrimary: e.isPrimary,
      enabled: e.enabled,
      rotationSource: r ? "explicit" : e.rotationSource
    };
  }) };
}
function M(t) {
  if (!t) return null;
  const n = t.getDocumentRoot();
  return n?.getBehavior(P) ? n : t.getSceneRoot();
}
var I = 0.7, B = 3, W = 1500;
function F(t, n, e = I) {
  const r = 1 / Math.tan(t.fov / 2), o = (typeof window < "u" ? window.innerWidth : 1) / (typeof window < "u" ? window.innerHeight : 1);
  return n * (o >= 1 ? r : r / o) / (2 * e);
}
async function it(t, n, e, r = m.Free) {
  const o = t.traceScene?.getSessionDocumentRoot() ?? t.traceScene?.getSceneRoot();
  if (!o) {
    p.warn("[attachImageAnchor] No scene root");
    return;
  }
  await o.setBehavior(P, {
    src: n,
    widthMeters: e,
    orientation: r
  });
}
function $(t) {
  const n = t.getBehavior(P), e = b(n?.orientation, n?.pitchDegrees, t.getChildren());
  return Math.cos(e) >= -Math.sin(e);
}
function V(t) {
  const n = M(t);
  if (!n) return;
  const e = n.getBehavior(P), r = e?.orientation, o = b(r, e?.pitchDegrees, n.getChildren()), c = d.RotationYawPitchRoll(0, o, 0);
  n.transform.rotationQuaternion = c, p.log(`[applyAnchorRotation] orientation=${r ?? "unset"}, pitch=${(o * 180 / Math.PI).toFixed(2)}°`);
  const i = n.getChildren(), s = i.length > 0 ? z(n) : [];
  if (i.length > 0) {
    n.transform.computeWorldMatrix(!0);
    let a = 1 / 0;
    for (const l of i) for (const u of l.transform.getChildMeshes(!1)) {
      if (s.some((h) => u.isDescendantOf(h.transform))) continue;
      u.computeWorldMatrix(!0);
      const f = u.getBoundingInfo().boundingBox.minimumWorld.y;
      f < a && (a = f);
    }
    isFinite(a) && a < 0 && (n.transform.position.y -= a, p.log(`[applyAnchorRotation] Anchor lifted by ${(-a).toFixed(4)}m to keep content above ground`));
  }
  for (const a of s) L(a, a.getParent());
}
function H(t, n, e) {
  const r = M(t);
  if (!r) return;
  const o = t.getCamera();
  if (!o) return;
  r.transform.computeWorldMatrix(!0);
  for (const a of r.getChildren()) for (const l of a.transform.getChildMeshes(!1)) l.computeWorldMatrix(!0);
  const c = $(r), i = r.transform.getAbsolutePosition(), s = Math.max(F(o, n, e ?? I), 0.01);
  o.target.copyFrom(i), o.lowerRadiusLimit = 0, o.radius = s, c ? (o.alpha = Math.PI / 2, o.beta = Math.PI / 2) : (o.alpha = Math.PI / 2, o.beta = 0.01), o.minZ = 0.01, o.maxZ = 100, p.log(`[frameAnchorCamera] target=(${i.x.toFixed(3)}, ${i.y.toFixed(3)}, ${i.z.toFixed(3)}), radius=${s.toFixed(3)}, beta=${o.beta.toFixed(3)}, imageWidth=${n.toFixed(3)}`);
}
function ct(t, n, e) {
  const r = t.traceScene;
  r && (V(r), H(r, n, e));
}
function U(t, n, e = {}) {
  const r = M(t);
  if (!r) return;
  const o = new d(n.q[0], n.q[1], n.q[2], n.q[3]), c = new R(n.t[0], n.t[1], n.t[2]);
  e.preserveContentWorldPose ? q(r, c, o) : (r.transform.position.copyFrom(c), r.transform.rotationQuaternion = o, O(r)), p.log(`[applyPlacementAnchorPose] t=(${n.t.map((i) => i.toFixed(3)).join(", ")}), q=(${n.q.map((i) => i.toFixed(4)).join(", ")})`);
}
function q(t, n, e) {
  const r = t.transform.rotationQuaternion?.clone() ?? d.FromEulerVector(t.transform.rotation), o = t.transform.position.clone(), c = d.Inverse(e);
  for (const i of t.getChildren()) {
    const s = i.transform.rotationQuaternion?.clone() ?? d.FromEulerVector(i.transform.rotation), a = i.transform.position.multiply(t.transform.scaling);
    a.rotateByQuaternionToRef(r, a), a.addInPlace(o).subtractInPlace(n), a.rotateByQuaternionToRef(c, a), i.transform.position.copyFrom(a.divide(t.transform.scaling)), i.transform.rotationQuaternion = c.multiply(r.multiply(s));
  }
  t.transform.position.copyFrom(n), t.transform.rotationQuaternion = e;
}
function st(t, n, e) {
  return v(b(n, e, t.getChildren()));
}
function Z(t, n, e, r) {
  const o = t.getCamera();
  if (!o) return;
  const c = M(t);
  c?.transform.computeWorldMatrix(!0);
  const i = c?.transform.absoluteRotationQuaternion ?? new d(n.q[0], n.q[1], n.q[2], n.q[3]), s = new R(0, 0, 1).applyRotationQuaternion(i), a = new R(0, 1, 0).applyRotationQuaternion(i), l = c?.transform.getAbsolutePosition().clone() ?? new R(n.t[0], n.t[1], n.t[2]), u = r ?? I;
  o.target.copyFrom(l), o.lowerRadiusLimit = 0, o.radius = Math.max(F(o, e, u), 0.01);
  const f = 0.01;
  o.beta = Math.min(Math.max(Math.acos(Math.max(-1, Math.min(1, s.y))), f), Math.PI - f), o.alpha = Math.abs(s.y) > 0.999 ? Math.atan2(-a.z * Math.sign(s.y), -a.x * Math.sign(s.y)) : Math.atan2(s.z, s.x), o.minZ = 0.01, o.maxZ = 100;
}
function lt(t, n, e, r) {
  const o = t.traceScene;
  o && (U(o, n), Z(o, n, e, r));
}
function ut(t, n, e) {
  const r = t.traceScene;
  if (!r) return;
  const o = r.getCamera();
  if (!o) return;
  const c = o.radius, i = c * B, s = r.getBabylonScene();
  let a = null, l = null;
  if (n && e) try {
    a = x.FromHexString(n), l = x.FromHexString(e), s.clearColor = new A(a.r, a.g, a.b, 1);
  } catch {
  }
  let u = -1;
  const f = s.onBeforeRenderObservable.add(() => {
    u < 0 && (u = performance.now());
    const h = Math.min((performance.now() - u) / W, 1), y = 1 - (1 - h) * (1 - h) * (1 - h);
    o.radius = c + (i - c) * y, a && l && (s.clearColor = new A(a.r + (l.r - a.r) * y, a.g + (l.g - a.g) * y, a.b + (l.b - a.b) * y, 1)), h >= 1 && s.onBeforeRenderObservable.remove(f);
  });
}
export {
  Q as _,
  V as a,
  rt as b,
  H as c,
  st as d,
  tt as f,
  C as g,
  ot as h,
  ut as i,
  Z as l,
  et as m,
  lt as n,
  U as o,
  X as p,
  M as r,
  it as s,
  ct as t,
  $ as u,
  nt as v,
  at as x,
  v as y
};

//# sourceMappingURL=ImageMarkerLoader-aTenj78C.js.map